document.addEventListener('scroll', function () {
    const icon_all = document.querySelectorAll('[data-animated-icon]');
    const stickers_all = document.querySelectorAll('.sticker-svg');


    if (icon_all.length > 0) {
        icon_all.forEach((icon) => {
            let visible = isInViewport(icon) ? 1 : 0;
            let targeted_path = icon.getAttribute('data-animated-icon');
            if (visible) {
                icon.querySelectorAll('path').forEach((element, index) => {
                    let class_add = targeted_path + "_" + index;
                    element.classList.add(class_add);
                    element.style.opacity = '1';
                })
            }
            else {
                icon.querySelectorAll('path').forEach((element, index) => {
                    let class_add = targeted_path + "_" + index;
                    element.classList.remove(class_add);
                    element.style.opacity = '0';
                })
            }
        })

    }

    if (stickers_all.length > 0) {
        stickers_all.forEach((sticker) => {
            let visible = isInViewportForStickers(sticker) ? 1 : 0;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const stickerTop = sticker.offsetTop;
            if (visible) {
                sticker.classList.add('fadeInUp');
                // if (scrollTop > stickerTop) {
                //     sticker.style.backgroundColor = "red";
                // }
            }

        })
    }

});

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= ((window.innerHeight) || (document.documentElement.clientHeight)) &&
        rect.right <= ((window.innerWidth) || (document.documentElement.clientWidth))

    );
}

function isInViewportForStickers(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= ((window.innerHeight - 100) || (document.documentElement.clientHeight - 100)) &&
        rect.right <= ((window.innerWidth) || (document.documentElement.clientWidth))

    );
}

function toggleBoxDetailsShowMore(contentBlock, tabcontent, shouldOpen) {
    if (!contentBlock || !tabcontent) return;

    const contentBlockHeight = Utility._getHeightofHiddenEle(contentBlock);

    if (shouldOpen) {
        contentBlock.style.height = contentBlockHeight + 'px';
        setTimeout(() => {
            contentBlock.style.height = '';
        }, 300);
        contentBlock.classList.add('show-more');
        tabcontent.classList.add('show-more-wrapper');
        return;
    }

    contentBlock.style.height = contentBlockHeight + 'px';
    setTimeout(() => {
        contentBlock.style.height = '52px';
    }, 1);
    setTimeout(() => {
        contentBlock.classList.remove('show-more');
        tabcontent.classList.remove('show-more-wrapper');
        contentBlock.style.height = '';
    }, 300);
}

function includeSubscriptionMultiShowMore() {
    return window.matchMedia('(max-width: 1200px)').matches;
}

function includeSubFullShowMore() {
    return window.matchMedia('(max-width: 1199px)').matches;
}

function getShowMoreTabTargets(root) {
    const targets = [];
    const selectors = ['[data-subscription-show-more-block] .subscription-product-box-style-1 .tabcontent'];

    if (includeSubFullShowMore()) {
        selectors.push('[data-sub-full-block] .subscription-product-box-style-1 .tabcontent');
    }

    if (includeSubscriptionMultiShowMore()) {
        selectors.push('[data-subscription-multi-show-more] .tabcontent');
    }

    root.querySelectorAll(selectors.join(', ')).forEach((tabcontent) => {
        const contentBlock = tabcontent.querySelector('.box-details-wrapper');
        if (contentBlock && tabcontent.querySelector('[data-cta-show-more-details]')) {
            targets.push({ contentBlock, tabcontent });
        }
    });

    return targets;
}

function getShowMoreOpenStateSelector() {
    let selector = '[data-subscription-show-more-block] .tabcontent.show-more-wrapper';

    if (includeSubFullShowMore()) {
        selector += ', [data-sub-full-block] .tabcontent.show-more-wrapper';
    }

    if (includeSubscriptionMultiShowMore()) {
        selector += ', [data-subscription-multi-show-more] .tabcontent.show-more-wrapper';
    }

    return selector;
}

document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cta-show-more-details] a');
    if (!link) return;

    event.preventDefault();

    if (link.closest('[data-subscription-multi-show-more]') && !includeSubscriptionMultiShowMore()) {
        return;
    }

    if (link.closest('[data-sub-full-block]') && !includeSubFullShowMore()) {
        return;
    }

    const syncSection = link.closest('[data-sync-show-more-details]');
    const syncAllBlocks = syncSection && window.matchMedia('(min-width: 768px)').matches;

    if (syncAllBlocks) {
        const targets = getShowMoreTabTargets(syncSection);
        const shouldOpen = syncSection.querySelectorAll(getShowMoreOpenStateSelector()).length === 0;

        targets.forEach(({ contentBlock, tabcontent }) => {
            toggleBoxDetailsShowMore(contentBlock, tabcontent, shouldOpen);
        });
        return;
    }

    const tabcontent = link.closest('.tabcontent');
    const contentBlock = tabcontent?.querySelector('.box-details-wrapper');
    if (!contentBlock) return;

    toggleBoxDetailsShowMore(contentBlock, tabcontent, !contentBlock.classList.contains('show-more'));
});